export default {
  getShareOfVoiceRecommendation: (state) => state.shareOfVoiceRecommendation,
};
